<div class="dds-dialog">

  <!-- header -->
  <div class="dds-header">
    <div>
      <h2 class="dds-title">Venda direta</h2>
      <p class="dds-subtitle">Registre uma proposta em nome do comprador sem que ele precise acessar a plataforma.</p>
    </div>
    <button class="dds-close-btn" type="button" (click)="close()" aria-label="Fechar">
      <i class="material-icons">close</i>
    </button>
  </div>

  <!-- área scrollável -->
  <div class="dds-scroll-body">

    <!-- ── STEP 1: Localizar comprador ─────────────── -->
    <div class="dds-step-block">
      <div class="dds-step-label">
        <span class="dds-step-badge">1</span>
        Localizar comprador
      </div>

      <div class="dds-search-field">
        <label class="dds-field-label" for="direct-sale-cpf-cnpj">CPF/CNPJ</label>
        <div class="dds-search-row">
          <div class="dds-input-wrapper">
            <i class="material-icons dds-input-icon">search</i>
            <input
              id="direct-sale-cpf-cnpj"
              class="form-control dds-input"
              type="text"
              name="directSaleCpfCnpj"
              [(ngModel)]="cpfCnpj"
              (ngModelChange)="onCpfCnpjChange()"
              (keyup.enter)="searchDealer()"
              mask="AA.AAA.AAA/AAAA-00||000.000.000-00"
              [dropSpecialCharacters]="false"
              placeholder="Digite o CPF ou CNPJ"
              autocomplete="off"
            />
          </div>
          <button
            class="btn btn-primary btn-rounded dds-btn-search"
            (click)="searchDealer()"
            [disabled]="loading || !cpfCnpj"
          >
            @if (loading && lastSearch === 'cpfCnpj') {
              <span class="btn-spinner"></span>
            } @else {
              <i class="material-icons dds-btn-icon">person_search</i>
            }
            Buscar comprador
          </button>
        </div>
      </div>

      <p class="dds-search-or">ou</p>

      <div class="dds-search-field">
        <label class="dds-field-label" for="direct-sale-phone">Telefone</label>
        <div class="dds-search-row">
          <div class="dds-input-wrapper">
            <i class="material-icons dds-input-icon">phone</i>
            <input
              id="direct-sale-phone"
              class="form-control dds-input"
              [class.dds-input--invalid]="phoneInvalid"
              type="text"
              name="directSalePhone"
              [(ngModel)]="phoneNumber"
              (ngModelChange)="onPhoneChange()"
              (keyup.enter)="searchDealerByPhone()"
              mask="(00) 00000-0000||(00) 0000-0000"
              [dropSpecialCharacters]="false"
              placeholder="Digite o telefone com DDD"
              autocomplete="off"
            />
          </div>
          <button
            class="btn btn-primary btn-rounded dds-btn-search"
            (click)="searchDealerByPhone()"
            [disabled]="loading || !phoneNumber"
          >
            @if (loading && lastSearch === 'phone') {
              <span class="btn-spinner"></span>
            } @else {
              <i class="material-icons dds-btn-icon">person_search</i>
            }
            Buscar comprador
          </button>
        </div>
      </div>

      <!-- feedback: erro -->
      @if (errorMessage) {
      <div class="dds-feedback dds-feedback--error">
        <i class="material-icons dds-feedback-icon">error_outline</i>
        {{ errorMessage }}
      </div>
      }

      <!-- feedback: não encontrado -->
      @if (notFound) {
      <div class="dds-feedback dds-feedback--warning">
        <i class="material-icons dds-feedback-icon">person_off</i>
        {{ notFoundMessage }}
      </div>
      }

      @if (dealerOptions.length > 1) {
      <p class="dds-search-hint">Mais de um comprador encontrado. Selecione o comprador desejado.</p>
      <div class="dds-dealer-options">
        @for (option of dealerOptions; track option.id) {
        <button
          type="button"
          class="dds-dealer-option"
          [class.dds-dealer-option--selected]="dealer?.id === option.id"
          (click)="selectDealer(option)"
        >
          <span class="dds-dealer-option-name">{{ option.name || '-' }}</span>
          <span class="dds-dealer-option-meta">{{ formatDocument(option.cpfCnpj) }} · {{ option.city || '-' }}/{{ option.uf || '-' }}</span>
        </button>
        }
      </div>
      }

      <!-- card do comprador localizado -->
      @if (dealer) {
      <div class="dds-dealer-card">
        <div class="dds-dealer-header">
          <div class="dds-dealer-avatar">
            <i class="material-icons">storefront</i>
          </div>
          <div>
            <p class="dds-dealer-name">{{ dealer.name || '-' }}</p>
            <p class="dds-dealer-location">
              <i class="material-icons dds-inline-icon">location_on</i>
              {{ dealer.city || '-' }}/{{ dealer.uf || '-' }}
            </p>
          </div>
          <span class="dds-found-badge">
            <i class="material-icons">check_circle</i>
            Comprador localizado
          </span>
        </div>

        <div class="dds-info-grid">
          <div class="dds-info-item">
            <span class="dds-info-label">
              <i class="material-icons dds-inline-icon">badge</i> CPF/CNPJ
            </span>
            <span class="dds-info-value">{{ cpfCnpjDisplay }}</span>
          </div>
          <div class="dds-info-item">
            <span class="dds-info-label">
              <i class="material-icons dds-inline-icon">email</i> E-mail
            </span>
            <span class="dds-info-value">{{ emailDisplay }}</span>
          </div>
          <div class="dds-info-item">
            <span class="dds-info-label">
              <i class="material-icons dds-inline-icon">phone</i> Telefone(s)
            </span>
            <span class="dds-info-value">{{ phoneNumbersDisplay }}</span>
          </div>
          <div class="dds-info-item">
            <span class="dds-info-label">
              <i class="material-icons dds-inline-icon">schedule</i> Último acesso
            </span>
            <span class="dds-info-value">
              {{ dealer.lastAccess ? (dealer.lastAccess | relativetimePT) : '-' }}
            </span>
          </div>
        </div>
      </div>
      @if (dealerBlockedMessage) {
      <div class="dds-feedback dds-feedback--error">
        <i class="material-icons dds-feedback-icon">warning</i>
        {{ dealerBlockedMessage }}
      </div>
      }
      }
    </div>

    @if (dealer && !isDealerBlocked) {
    <div class="dds-step-block">
      <div class="dds-step-label">
        <span class="dds-step-badge">2</span>
        Valor da proposta
      </div>

      <div class="dds-proposal-row">
        <div class="dds-currency-input-wrapper">
          <span class="dds-currency-prefix">R$</span>
          <input
            id="direct-sale-proposal-value"
            class="form-control dds-currency-input"
            type="text"
            currencyMask
            [options]="{ prefix: '', thousands: '.', decimal: ',', precision: 0, allowNegative: false }"
            name="directSaleProposalValue"
            [(ngModel)]="proposalValue"
            placeholder="0"
            autocomplete="off"
          />
        </div>
        <p class="dds-proposal-hint">O valor será registrado como proposta deste comprador no veículo.</p>
        @if (proposalMargin != null) {
          <div class="dds-margin-row">
            <span>Margem da proposta</span>
            <span>{{ proposalMargin | percent:'0.1-1' }}</span>
          </div>
        }
        @if (userLimitLabel) {
          <div class="dds-margin-row">
            <span>Seu limite</span>
            <span>{{ userLimitLabel }}</span>
          </div>
        }
        @if (isMarginBlocked) {
          <p class="dds-margin-alert">A margem está abaixo do limite permitido para o seu perfil.</p>
        }
      </div>
    </div>

    <!-- ── STEP 3: Modo de finalização ───────────── -->
    <div class="dds-step-block">
      <div class="dds-step-label">
        <span class="dds-step-badge">3</span>
        O que deseja fazer após registrar a proposta?
      </div>

      <div class="dds-mode-cards">

        @if (canShowFinishModes) {
        <!-- finalizar agora -->
        <button
          type="button"
          class="dds-mode-card"
          [class.dds-mode-card--selected]="mode === 'FINISH_NOW'"
          (click)="selectMode('FINISH_NOW')"
        >
          <div class="dds-mode-card-icon">
            <i class="material-icons">gavel</i>
          </div>
          <div class="dds-mode-card-body">
            <span class="dds-mode-card-title">Finalizar a venda agora</span>
            <span class="dds-mode-card-desc">A negociação será encerrada com este valor imediatamente.</span>
          </div>
          <i class="material-icons dds-mode-card-check">check_circle</i>
        </button>

        <!-- manter aberta -->
        <div
          class="dds-mode-card dds-mode-card--expandable"
          [class.dds-mode-card--selected]="mode === 'KEEP_OPEN'"
        >
          <div class="dds-mode-card-main" (click)="selectMode('KEEP_OPEN')">
            <div class="dds-mode-card-icon">
              <i class="material-icons">hourglass_bottom</i>
            </div>
            <div class="dds-mode-card-body">
              <span class="dds-mode-card-title">Manter a negociação aberta</span>
              <span class="dds-mode-card-desc">A proposta entra, mas outros compradores ainda podem superar o valor.</span>
            </div>
            <i class="material-icons dds-mode-card-check">check_circle</i>
          </div>

          @if (mode === 'KEEP_OPEN') {
          <div class="dds-time-section">
            <div class="dds-time-options">
              <button
                type="button"
                class="dds-time-chip"
                [class.dds-time-chip--selected]="isKeepCurrentScheduleSelected"
                (click)="selectKeepCurrentSchedule()"
              >
                <i class="material-icons">event_available</i>
                Manter horário atual
              </button>
              @for (opt of keepOpenOptions; track opt.minutes) {
              <button
                type="button"
                class="dds-time-chip"
                [class.dds-time-chip--selected]="isKeepOpenSelected(opt.minutes)"
                (click)="selectKeepOpen(opt.minutes)"
              >
                <i class="material-icons">{{ opt.icon }}</i>
                {{ opt.label }}
              </button>
              }
            </div>
            @if (isKeepCurrentScheduleSelected) {
            <p class="dds-time-hint">A proposta será inserida sem alterar o prazo da negociação.</p>
            }
          </div>
          }
        </div>
        }

        @if (canShowConditionalMode) {
        <button
          type="button"
          class="dds-mode-card"
          [class.dds-mode-card--selected]="mode === 'SEND_TO_CONDITIONAL'"
          (click)="selectMode('SEND_TO_CONDITIONAL')"
        >
          <div class="dds-mode-card-icon">
            <i class="material-icons">pending_actions</i>
          </div>
          <div class="dds-mode-card-body">
            <span class="dds-mode-card-title">Mandar para condicional</span>
            <span class="dds-mode-card-desc">A proposta fica pendente de aceite ou recusa. A negociação não permanece aberta para novas ofertas.</span>
          </div>
          <i class="material-icons dds-mode-card-check">check_circle</i>
        </button>
        }

      </div>
    </div>
    }

  </div><!-- /dds-scroll-body -->

  <!-- ações: sempre fixas no rodapé -->
  <div class="dds-actions">
    <button class="btn btn-link dds-btn-cancel" type="button" (click)="close()">Cancelar</button>
    <button
      class="btn btn-primary btn-rounded dds-btn-confirm"
      type="button"
      (click)="submitProposal()"
      [disabled]="submitting || !canSubmit"
    >
      @if (submitting) {
        <span class="btn-spinner dds-spinner"></span>
      }
      Confirmar proposta
    </button>
  </div>

</div>
